/**
 * Is there any overlap between times A and B if the following are true
 * - A starts before B ends
 * - B starts before A ends
 * @param startA
 * @param endA
 * @param startB
 * @param endB
 */
export const hasOverlap = (
  startA: Date | number,
  endA: Date | number,
  startB: Date | number,
  endB: Date | number,
): boolean => {
  return endA >= startB && startA <= endB;
};

interface Overlap {
  start: number;
  end: number;
}

const toNumber = (val: number | Date) => +val;

export const getOverlap = (
  startA: number | Date,
  endA: number | Date,
  startB: number | Date,
  endB: number | Date,
): Overlap | undefined => {
  const overlap = hasOverlap(startA, endA, startB, endB);
  if (!overlap) {
    return undefined;
  }

  const start = startA > startB ? startA : startB;
  const end = endA < endB ? endA : endB;

  return {
    start: toNumber(start),
    end: toNumber(end),
  };
};
